import { render, staticRenderFns } from "./SalesOrders.vue?vue&type=template&id=5cc19591&scoped=true"
import script from "./SalesOrders.vue?vue&type=script&lang=js"
export * from "./SalesOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc19591",
  null
  
)

export default component.exports